import { styled } from 'styled-components'
import SPACES from '@web-ui-kit/spaces'

export const Container = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme?.colors?.ACCENT_20};
  display: flex;
  gap: ${SPACES.L};
  justify-content: space-between;
  left: ${({ $isSmall }) => ($isSmall ? 0 : '3.5rem')};
  padding: ${SPACES.M} ${SPACES.L};
  position: absolute;
  right: 0;
  top: 0;
  z-index: ${({ $isSmall }) => ($isSmall ? '20' : '1')};
`

export const Close = styled.div`
  cursor: pointer;
`
